export default "__VITE_ASSET__CUhtWh2q__"